export default {
    login_failure: 'login_failure',
    account_locked: 'account_locked',
    notLoggedIn: 'notLoggedIn',
    loginError: 'checkIfLoggedInError',
    invalidTokenOrEmail: 'invalidTokenOrEmail',
    autoLoginError: 'autoLoginError',
    userAlreadyExists: 'userAlreadyExists',
    emailNotFound: 'emailNotFound',
    loadTimeout: 'loadTimeout',
    expectedSrcPartOnLoad: 'expectedSrcPartOnLoad',
    iframeLoadError: 'iframeLoadError',
    fieldEmpty: 'fieldEmpty',
    invalidAttempt: 'invalidAttempt',
    fieldIncorrect: 'fieldIncorrect',
    invalidToken: 'invalidToken'
};
